const SERVER_API = 'http://ts-sand.shreegrgoilmill.com/backend/public/api';
export{SERVER_API};
const PUSHER_API = 'http://ts-sand.shreegrgoilmill.com/backend/public/broadcasting/auth' 
export{PUSHER_API};
const PUSHER_KEY = 'ae7f879a57884f61cc77'
export{PUSHER_KEY};